'use strict';

var processInclude = require('./util'),
    $ = require('jquery');

$(document).ready(function () {
    processInclude(require('./productDetailPage/productDetailPage'));
});
